import HorizontalTimelineContainer from './containers/HorizontalTimelineContainer'

export const containers = {
  HorizontalTimelineContainer,
}
